import { Map } from 'immutable';
import AppDispatcher from '../AppDispatcher';
import Constants from '../Constants';

import TokenStore from '../stores/TokenStore';
import CurrentOrganizationIdStore from '../stores/CurrentOrganizationIdStore';
import CredAPI from '../util/CredAPI';

const ResourceActions = {
  getResources() {
    const api = new CredAPI(TokenStore.getToken()).creds;
    api.getResources().then((resources) => {
      AppDispatcher.dispatch({
        actionType: Constants.Credentials.RESOURCES_RECEIVED,
        resources,
      });
    });
  },

  addEmptyResource() {
    AppDispatcher.dispatch({
      actionType: Constants.Credentials.NEW_RESOURCE_ADDED,
    });
  },

  removeUnsavedResource() {
    AppDispatcher.dispatch({
      actionType: Constants.Credentials.NEW_RESOURCE_REMOVED,
    });
  },

  saveResource(resource) {
    const resourceParams = new Map({
      organization_id: CurrentOrganizationIdStore.getState(),
      resource_type: resource.resourceType,
      resource_name: resource.resourceName,
      resource_info: resource.resourceInfo,
    });

    const resourceParamsNoNulls = resourceParams.filter(v => v !== null);

    if (resource.id > 0) {
      this.updateResource(resource.id, resourceParamsNoNulls);
    } else {
      this.createResource(resourceParams);
    }
  },

  // Resource CRUD Actions
  createResource(newResource) {
    const api = new CredAPI(TokenStore.getToken()).creds;
    api.postResource(newResource).then((resource) => {
      AppDispatcher.dispatch({
        actionType: Constants.Credentials.RESOURCE_CREATED,
        resource,
      });
    });
  },

  getResource(resourceId) {
    const api = new CredAPI(TokenStore.getToken()).creds;
    api.getResource(resourceId).then((resource) => {
      AppDispatcher.dispatch({
        actionType: Constants.Credentials.RESOURCE_RECEIVED,
        resource,
      });
    });
  },

  updateResource(resourceId, newResourceParams) {
    const api = new CredAPI(TokenStore.getToken()).creds;
    api.updateResource(resourceId, newResourceParams).then((resource) => {
      AppDispatcher.dispatch({
        actionType: Constants.Credentials.RESOURCE_RECEIVED,
        resource,
      });
    });
  },

  deleteResource(resourceId) {
    const api = new CredAPI(TokenStore.getToken()).creds;
    api.deleteResource(resourceId).then(() => {
      AppDispatcher.dispatch({
        actionType: Constants.Credentials.RESOURCE_DELETED,
        resourceId,
      });
    });
  },
};

export default ResourceActions;
